import React from 'react';
import { useTheme } from 'styled-components';
import getIsMobile from '../atoms/utils/getIsMobile';

const isMobile = getIsMobile();

export const ListColsSvg = (props) => {

  const { selected, onClick, width, height, color } = props;

  const theme = useTheme();

  if (selected) {
    return (
      <svg onClick={onClick} width={width ?? "18"} height={height ?? "17"} viewBox="0 0 18 17" fill={color ?? theme?.colour?.primary ?? "#1DBD6B"} xmlns="http://www.w3.org/2000/svg">
        <rect x="0.466797" y="0.0859375" width="7.72549" height="7.5502" rx="2" />
        <rect x="9.31885" y="0.0859375" width="7.72549" height="7.5502" rx="2" />
        <rect x="9.31885" y="9.11328" width="7.72549" height="7.5502" rx="2" />
        <rect x="0.466797" y="9.11328" width="7.72549" height="7.5502" rx="2" />
      </svg>
    )
  } else {

    if (isMobile) {
      return (
        <svg onClick={onClick} width={width ?? "18"} height={height ?? "17"} viewBox="0 0 18 17" fill="#C2CCCE" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.466797" y="0.0859375" width="7.72549" height="7.5502" rx="2" />
          <rect x="9.31885" y="0.0859375" width="7.72549" height="7.5502" rx="2" />
          <rect x="9.31885" y="9.11328" width="7.72549" height="7.5502" rx="2" />
          <rect x="0.466797" y="9.11328" width="7.72549" height="7.5502" rx="2" />
        </svg>
      )
    }
    return (
      <svg onClick={onClick} width={width ?? "18"} height={height ?? "17"} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.966797" y="0.832031" width="6.72549" height="6.5502" rx="1.5" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="9.81909" y="0.832031" width="6.72549" height="6.5502" rx="1.5" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="9.81909" y="9.85941" width="6.72549" height="6.5502" rx="1.5" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
        <rect x="0.966797" y="9.85941" width="6.72549" height="6.5502" rx="1.5" stroke={color ?? theme?.colour?.primary ?? "#1DBD6B"} />
      </svg>
    )
  }
}